const strings = {
  NAME: "BRF",
  BILLING_AND_CONTACT_EMAIL: "Email",
  CONTACT_NUMBER: "Telefon",
  CONTACT_FIRST_NAME: "Förnamn",
  CONTACT_LAST_NAME: "Efternamn",
  ADDRESS: "Adress",
  ZIP_CODE: "Postkod",
  CITY: "Stad",
  PRICE: "Pris",
  ORG_NUMBER: "Organisationnummer",
  FREE_TRIAL_EXPIRES: "Första betalningsdag",
  CREATED_AT: "Skapades",
  NEW_CORPORATION: "Nytt företag",
  CUSTOMERS: "BRF:er"
};

export default strings;



// WEBPACK FOOTER //
// ./src/components/containers/CorporationTable/strings.js